import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { GamesService } from '../../../../services/games/games.service';
import { GameSearchService } from '../../../../services/games/game-search.service';
import { GameFilterService } from '../../../../services/games/game-filter.service';
import { FiltersService } from '../../../../services/filters.service';
import { GameCategoryAttrService } from '../../../../services/games/game-category-attribute.service';
import { BreakpointsDetectorService } from 'src/app/core/services/breakpoints-detector.service';
import { TranslatePipe } from '../../../../services/translation/translate.pipe';
import { GamesFilterBarComponent } from '../games-filter-bar/games-filter-bar.component';
import { GamesSearchBarComponent } from '../games-search-bar/games-search-bar.component';
import { GamesFilterComponent } from '../games-filter/games-filter.component';
import { GamesSearchComponent } from '../games-search/games-search.component';
import { NgClass } from '@angular/common';
import { ClickOutsideDirective } from 'ngx-unificator/directives';

@Component({
    selector: 'app-search-popup',
    templateUrl: './search-popup.component.html',
    styleUrls: ['./search-popup.component.scss'],
    imports: [
        ClickOutsideDirective,
        NgClass,
        GamesSearchComponent,
        GamesFilterComponent,
        GamesSearchBarComponent,
        GamesFilterBarComponent,
        TranslatePipe,
    ]
})
export class SearchPopupComponent implements OnInit, OnDestroy {
  games = inject(GamesService);
  gamesSearch = inject(GameSearchService);
  breakPoint = inject(BreakpointsDetectorService);
  private _gamesFilter = inject(GameFilterService);
  private _filtersService = inject(FiltersService);
  private _category = inject(GameCategoryAttrService);


  ngOnInit(): void {}

  ngOnDestroy() {
    this.gamesSearch.sub.unsubscribe();
  }

  onSubmitFilter() {
    this._gamesFilter.applyFilters(this._gamesFilter.setFormDataForFilters()).then(() => {
      this.gamesSearch.searchForm.enable();
      if (this.gamesSearch.showPopup) {
        this.gamesSearch.togglePopup();
      }
    });
  }

  onCancelFilter() {
    if (this.gamesSearch.showFiltersBar) {
      this.gamesSearch.showFiltersBar = false;
    }
  }

  onClosePopup() {
    this.gamesSearch.showPopup = false;
    this.gamesSearch.onClose();
  }
}
